import { Interceptor } from 'api/requestUtils'

export default function browserErrorLogger(): Interceptor {
  return f => f.catch((error: any) => {
    console.error('API Error', JSON.stringify(error, null, 2))

    throw error
  })
}
